import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import { TableContext } from '@/context/TableContext';

const createStyles = (colors, noRadius) => StyleSheet.create({
  tableContainer: {
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
    borderRadius: noRadius ? 0 : 8,
    overflow: 'hidden',
  },
  tableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.border_color_secondary,
    backgroundColor: colors.solid_color_tertiary,
    height: 40,
  },
  headerText: {
    fontWeight: '500',
  },
  columnHeader: {
    justifyContent: 'center',
  },
});

const BasicTable = ({
  children,
  columns = [],
  noRadius,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors, noRadius), [colors, noRadius]);

  // Memoize the context value
  const contextValue = useMemo(() => ({
    columns,
  }), [columns]);

  return (
    <TableContext.Provider value={contextValue}>
      <View style={styles.tableContainer}>
        <View style={styles.tableHeader}>
          {columns.map((column, index) => (
            <View 
              key={`column-header-${index}`} 
              style={[
                styles.columnHeader,
                { width: column.width },
                column.headerStyle,
              ]}
            >
              {typeof column.header === 'string' ? (
                <Text size="s" style={styles.headerText}>{column.header}</Text>
              ) : (
                column.header
              )}
            </View>
          ))}
        </View>
        {children}
      </View>
    </TableContext.Provider>
  );
};

export default BasicTable; 